import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import moment from "moment";
import { loader } from "react-global-loader";
import { useLocation, useNavigate } from "react-router-dom";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import {
  TransactionLogStatusEnum,
  TransactionLogTypeEnum,
  TransactionSourceEnum,
  respEnum,
} from "../../constants/appConstant";
import AdvanceTable from "../../components/advanceTable";
import { useQueryParams } from "../../contexts/queryParamsContext";
import {
  AppInput,
  AppSelect,
  AppSearchSectionSelect,
} from "../../components/appComponents";

const Transactions = () => {
  const [loading, setLoading] = useState(true);
  let location = useLocation();
  const { params, setParams } = useQueryParams();

  const navParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [data, setData] = useState({});

  const navigate = useNavigate();
  const [paramStatus, setParamStatus] = useState();
  const [startDate, setStartDate] = useState(null);
  const [tillDate, setTillDate] = useState(null);
  const [clubAccountId, setClubAccountId] = useState(null);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);
  const [paymentGatewayId, setPaymentGatewayId] = useState(null);
  const [transactionSource, setTransactionSource] = useState(null);

  useEffect(() => {
    let status = +navParams.get("status");
    setParamStatus(status);
    getClubPaymentTypes();
    getPaymentGateway();
    getData(1);
  }, [navParams]);

  const resetFilters = () => {
    setStartDate(null);
    setTillDate(null);
    setClubAccountId(null);
    setPaymentGatewayId(null);
    setTransactionSource(null);
  };

  useEffect(() => {
    getData(1);
  }, [startDate, tillDate, clubAccountId, paymentGatewayId, transactionSource]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    if (startDate && tillDate && startDate > tillDate) {
      Common.showToast("End Time must be greater", "Error", "info");
      return;
    }
    if (paymentGatewayId?.value && clubAccountId?.value) {
      Common.showToast(
        "You Can't Select Both Club Accounts and Payment Gateway ",
        "Error",
        "info"
      );
      setClubAccountId(null);
      setPaymentGatewayId(null);
      return;
    }

    setLoading(true);
    let status = +navParams.get("status");

    const response = await Common.ApiService.getInstance().request(
      "GetClubTransactions",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
        status,
        startDate,
        tillDate,
        clubAccountId: clubAccountId ? clubAccountId.value : null,
        paymentGatewayId: paymentGatewayId ? paymentGatewayId.value : null,

        transaction_source: transactionSource,
      },
      "Post",
      false
    );
    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          bookingDate: item.bookingDate
            ? `${moment(item.bookingDate).format("DD MMM yyyy")}`
            : "-",
          createdOn: Common.Utility.ConvertTime(item.createdOn),
          updatedOn: item.updatedOn
            ? Common.Utility.ConvertTime(item.updatedOn)
            : "-",
          // paymentTypeName: Common.Utility.getKeyByValue(
          //   PaymentTypeEnum,
          //   item.paymentType
          // ),
          paymentStatusName: Common.Utility.getKeyByValue(
            TransactionLogStatusEnum,
            item.status
          ),
          transactionTypeName: Common.Utility.getKeyByValue(
            TransactionLogTypeEnum,
            item.transactionType
          ),
          transaction_source: Common.Utility.getKeyByValue(
            TransactionSourceEnum,
            item.transaction_source ?? TransactionSourceEnum.Booking
          ),
          isByClub: item.isByClub ? "Yes" : "No",
          courtName: item.courtName ?? "-",
          posMachineName: item.posMachineName ?? "-",
        })),
      };

      setData(obj);
      setLoading(false);
    }
  };
  const MarkTransactionRefunded = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to Mark Payment as Refunded?",
      "Payment Refunded"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `MarkTransactionAsRefunded?id=${id}`,
        {},
        "Post"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData();
      }, 500);
    }
  };
  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const getClubPaymentTypes = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentTypes?isForReport=false"
    );

    if (response?.status == respEnum.Success) {
      setPaymentTypeList(response?.data ?? []);
    }
  };

  const getPaymentGateway = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentGateways"
    );

    if (response?.status == respEnum.Success) {
      setPaymentGateway(response?.data ?? []);
    }
  };

  const actions = (status) =>
    [
      {
        type: "view",
        // onClick: (val) => {
        //   setParams({
        //     ...params,
        //     bookingId: val.bookingId,
        //   });
        //   navigate(`/app/bookingDetails`);
        // },
        onClick: (val) => {
          if (val.bookingId) {
            setParams({
              ...params,
              bookingId: val.bookingId,
            });
            navigate(`/app/bookingDetails`);
          } else if (val.sale_order_id) {
            setParams({
              ...params,
              sale_order_id: val.sale_order_id,
            });
            navigate(`/app/pos-order-details?id=${val.sale_order_id}`);
          } 
          else if (val.amenitybookingid){
             setParams({
              ...params,
              amenitybookingid: val.amenitybookingid,
            });
            navigate(`/app/amenitybookingdetails?id=${val.amenitybookingid}`);
          }
        },
      },
      status === TransactionLogStatusEnum.Refundable && {
        type: "custom",
        button: (val) => (
          <button
            className="text-xs px-1 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 inline-block"
            onClick={() => MarkTransactionRefunded(val.id)}
          >
            Mark Refund
          </button>
        ),
      },
    ].filter(Boolean);

  let columns = [
    { title: "Basket Id", type: "text", key: "id" },
    { title: "Booking/Order Date", type: "text", key: "bookingDate" },
    { title: "Booking Detail", type: "text", key: "detail" },
    { title: "Player Name", type: "text", key: "playerName" },
    { title: "Amount", type: "text", key: "amount" },
    { title: "Court", type: "text", key: "courtName" },
    { title: "Transaction Type", type: "text", key: "transactionTypeName" },
    { title: "Payment Type", type: "text", key: "paymentTypeName" },
    { title: "Payment Account", type: "text", key: "clubAccountName" },
    { title: "POS Machine", type: "text", key: "posMachineName" },
    { title: "Player Phone #", type: "text", key: "playerCellNo" },
    { title: "Status", type: "text", key: "paymentStatusName" },

    { title: "Is By Club", type: "text", key: "isByClub" },
    {
      title: "Transaction Source",
      type: "text",
      key: "transaction_source",
    },

    { title: "Created On", type: "text", key: "createdOn" },
    { title: "Last Updated On", type: "text", key: "updatedOn" },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <style>
        {`
          .paddingleft6 {
            padding-left: 6px!important;
          }

          @media screen and (max-width: 768px) {
            .paddingleft6 {
              padding-left: 0px !important;
            }
          }
        `}
      </style>
      <div className="md:grid md:grid-cols-6 gap-3 ">
        <AppInput
          type={"date"}
          value={startDate}
          onChange={(e) => {
            const selectedstartDate = e;
            if (tillDate && selectedstartDate > tillDate) {
              Common.showToast(
                "Start Time must be lesser than End Time",
                "Error",
                "info"
              );
              setStartDate(null);
            } else {
              setStartDate(selectedstartDate);
            }
          }}
          label="Booking From"
          className="mb-3 col-span-1 paddingleft6"
        />

        <AppInput
          type={"date"}
          value={tillDate}
          onChange={(e) => {
            const selectedEndDate = e;
            if (selectedEndDate < startDate) {
              Common.showToast("End Time must be greater", "Error", "info");
              setTillDate("");
            } else {
              setTillDate(selectedEndDate);
            }
          }}
          label="Booking Till"
          className="mb-3 col-span-1"
        />

        <AppSearchSectionSelect
          value={clubAccountId}
          onChange={setClubAccountId}
          label="Account"
          data={paymentTypeList}
          className="mb-5 col-span-1"
        />

        <AppSearchSectionSelect
          value={paymentGatewayId}
          onChange={setPaymentGatewayId}
          label={"Payment Gateway"}
          data={paymentGateway}
          className="mb-5 col-span-1"
        />
        <AppSelect
          value={transactionSource}
          onChange={setTransactionSource}
          label="Transaction Source"
          data={[
            { id: null, name: "Select" },
            ...Common.Utility.enumToArray(TransactionSourceEnum),
          ]}
          className="mb-5 col-span-1"
        />

        <Button className="mb-2 mt-6 h-8" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={`Payment ${Common.Utility.getKeyByValue(
            TransactionLogStatusEnum,
            paramStatus
          )}`}
          columns={columns}
          data={data}
          getData={getData}
          showPagination
          actionButtons={actions(paramStatus)}
          updateTrigger={_addUpdateTrigger} // Example function
          showExportoptions
        />
      )}
    </>
  );
};

export default Transactions;
